/**
 * Marketing module
 *
 * Module index file
 *
 * This file is used by theme to provide default functionality
 * to the module and to register all components.
 *
 * This file has to export setup function that will be called
 * automatically by import in the theme app.ts file.
 */

import { App } from 'vue';
import VueGtag, { useGtag } from 'vue-gtag-next';
import type { PageView } from 'vue-gtag-next';
import { router } from '@inertiajs/vue3';

export const setup = (app: App<Element>): void => {
    if (window.marketing && window.marketing?.google_measurement_id) {
        app.use(VueGtag, {
            property: {
                id: window.marketing?.google_measurement_id,
                params: {
                    user_id: window.marketing?.params?.user_id,
                    send_page_view: false,
                },
            },
        });

        // Send page view event on route change
        router.on('navigate', (routerEvent: { detail: { page: { url: string } } }) => {
            const { pageview } = useGtag();

            pageview({ path_path: routerEvent?.detail?.page?.url } as PageView);
        });
    }
};
